import { CategoryViewModel } from '@dynamik/common/clients/transaction-clients';

export class CategoryConverterValueConverter {
  toView(categories: CategoryViewModel[] | string, typeid: number) {
    if (categories == null) {
      return '';
    }
    if (typeof categories == "object") {
      if (!categories?.length) {
        return '';
      }

      const filteredValue = categories.filter(cat => cat.securitiesCategoryType.id === typeid);
      if (filteredValue[0]) {
        return filteredValue[0].name;
      } else {
        return '';
      }
    }
    return categories;
  }
}
